export default "__VITE_ASSET__BFDusCmZ__"